import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Search, FilePlus2, Trash2 } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { tk, fmtDate } from "../lib/format";
import { PageHeader, Empty, Loader } from "../components/kit";
import { useDebounced } from "../components/ProductSearch";

export default function Memos() {
  const [q, setQ] = useState("");
  const [date, setDate] = useState("");
  const [list, setList] = useState<any[] | null>(null);
  const dq = useDebounced(q);
  const nav = useNavigate();

  const load = useCallback(() => {
    api.get("/memos", { params: { q: dq, date } }).then((r) => setList(r.data));
  }, [dq, date]);
  useEffect(() => { load(); }, [load]);

  const del = async (e: React.MouseEvent, m: any) => {
    e.stopPropagation();
    if (!window.confirm(`মেমো ${m.invoice_no} মুছে ফেলবেন?\nস্টক ফেরত যোগ হবে এবং ক্রেতার বাকি কমে যাবে। পরে আর্কাইভ থেকে রিস্টোর করা যাবে।`)) return;
    try {
      await api.delete(`/memos/${m.id}`);
      toast.success("মেমো আর্কাইভে সরানো হয়েছে");
      load();
    } catch (er) {
      toast.error(errMsg(er));
    }
  };

  return (
    <div>
      <PageHeader title="মেমো তালিকা" subtitle="আগের যেকোনো মেমো আবার খুলুন ও প্রিন্ট করুন" actions={<Link to="/memo/new" className="btn btn-primary" data-testid="memos-new-button"><FilePlus2 size={17} /> নতুন মেমো</Link>} />
      <div className="card p-4 flex flex-col sm:flex-row gap-3 mb-4">
        <div className="relative flex-1">
          <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input className="inp pl-10" placeholder="মেমো নং / ক্রেতার নাম / মোবাইল" value={q} onChange={(e) => setQ(e.target.value)} data-testid="memos-search-input" />
        </div>
        <input type="date" className="inp sm:w-48" value={date} onChange={(e) => setDate(e.target.value)} data-testid="memos-date-filter" />
      </div>
      <div className="card overflow-x-auto">
        {!list ? <Loader /> : list.length === 0 ? <Empty text="কোনো মেমো পাওয়া যায়নি" /> : (
          <table className="tbl" data-testid="memos-table">
            <thead><tr><th>মেমো নং</th><th>তারিখ</th><th>ক্রেতা</th><th className="text-right">সর্বমোট</th><th className="text-right">পরিশোধ</th><th className="text-right">বর্তমান বাকি</th><th /></tr></thead>
            <tbody>
              {list.map((m) => (
                <tr key={m.id} className="cursor-pointer" onClick={() => nav(`/memos/${m.id}`)} data-testid={`memo-row-${m.invoice_no}`}>
                  <td className="font-semibold text-blue-700">{m.invoice_no}</td>
                  <td className="num">{fmtDate(m.date)}</td>
                  <td>{m.customer?.name}</td>
                  <td className="text-right num font-semibold">{tk(m.grand_total)}</td>
                  <td className="text-right num text-emerald-700">{tk(m.paid)}</td>
                  <td className={`text-right num font-semibold ${m.current_due > 0 ? "text-red-600" : "text-emerald-700"}`}>{tk(m.current_due)}</td>
                  <td className="text-right whitespace-nowrap">
                    <button className="w-8 h-8 inline-grid place-items-center rounded-lg text-red-500 hover:bg-red-50" onClick={(e) => del(e, m)} data-testid={`memo-delete-${m.invoice_no}`} aria-label="মুছুন"><Trash2 size={15} /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
